import { jsxs, jsx } from "react/jsx-runtime";
import { useRef, useState, useEffect, useMemo, useCallback } from "react";
import "../Button/Button.js";
import "../InputControl/InputControl.js";
import "../InputControl/Input/InputBase.js";
import "../PhoneInputControl/PhoneInputControl.js";
import "../PhoneInputControl/PhoneInput/PhoneInput.js";
import "../IconButton/IconButton.js";
import "../common/ControlBody.js";
import "@mui/material";
import "../IconButtonNew/IconButton.js";
import "../../icons/24/Action/Close.js";
import "../../icons/24/Arrow/ChevronLeft.js";
import "../Dropdown/context/DropdownContext.js";
import "../Dropdown/DropdownWindow.js";
import { DATA_TEST_ID_INHERITED } from "../../constants/DATA_TEST_ID_INHERITED.js";
import "../../icons/24/System/Check.js";
import "../../icons/24/Arrow/ChevronDown.js";
import "../SelectControl/SelectInput/SelectInput.js";
import "../TextareaControl/TextareaControl.js";
import "../SearchControl/SearchControl.js";
import "../../icons/24/System/Search.js";
import "../FormattedPhone/FormattedPhoneNumber.js";
import "../../icons/24/Action/Attach.js";
import "../../icons/24/Action/Camera.js";
import "../../icons/24/Action/CameraPlus.js";
import "../../icons/24/Action/Cart.js";
import "../../icons/24/Action/ChatText.js";
import "../../icons/24/Action/ClockClockwise.js";
import "../../icons/24/Action/ClockCounterClockwise.js";
import "../../icons/24/Action/Comment.js";
import "../../icons/24/Action/Copy.js";
import "../../icons/24/Action/DelayedResult.js";
import "../../icons/24/Action/Delete.js";
import "../../icons/24/Action/DeliveredResult.js";
import "../../icons/24/Action/Edit.js";
import "../../icons/24/Action/ErrorCheck.js";
import "../../icons/24/Action/ErrorMinus.js";
import "../../icons/24/Action/ErrorPlus.js";
import "../../icons/24/Action/EyeDropper.js";
import "../../icons/24/Action/EyeOff.js";
import "../../icons/24/Action/EyeOn.js";
import "../../icons/24/Action/File.js";
import "../../icons/24/Action/FileCheck.js";
import "../../icons/24/Action/FilePdf.js";
import "../../icons/24/Action/FilePlus.js";
import "../../icons/24/Action/Folder.js";
import "../../icons/24/Action/FolderPlus.js";
import "../../icons/24/Action/Hand.js";
import "../../icons/24/Action/Heart.js";
import "../../icons/24/Action/Image.js";
import "../../icons/24/Action/Key.js";
import "../../icons/24/Action/Location.js";
import "../../icons/24/Action/Lock.js";
import "../../icons/24/Action/Map.js";
import "../../icons/24/Action/MassInput.js";
import "../../icons/24/Action/Message.js";
import "../../icons/24/Action/MessageOpen.js";
import "../../icons/24/Action/MessageSend.js";
import "../../icons/24/Action/PanelExpand.js";
import "../../icons/24/Action/PanelHide.js";
import "../../icons/24/Action/PauseCircle.js";
import "../../icons/24/Action/Pin.js";
import "../../icons/24/Action/PinSlash.js";
import "../../icons/24/Action/PlayCircle.js";
import "../../icons/24/Action/Print.js";
import "../../icons/24/Action/Rating.js";
import "../../icons/24/Action/RequestSend.js";
import "../../icons/24/Action/SlidersHorizontal.js";
import "../../icons/24/Action/SlidersVertical.js";
import "../../icons/24/Action/SortAscending.js";
import "../../icons/24/Action/SortDescending.js";
import "../../icons/24/Action/StopCircle.js";
import "../../icons/24/Action/Terminal.js";
import "../../icons/24/Action/Unlock.js";
import "../../icons/24/Action/User.js";
import "../../icons/24/Action/UserInfo.js";
import "../../icons/24/Action/UserPlus.js";
import "../../icons/24/Action/UsersThree.js";
import "../../icons/24/Arrow/ArrowDown.js";
import "../../icons/24/Arrow/ArrowLeft.js";
import "../../icons/24/Arrow/ArrowRedo.js";
import "../../icons/24/Arrow/ArrowRefresh.js";
import "../../icons/24/Arrow/ArrowRight.js";
import "../../icons/24/Arrow/ArrowRotate.js";
import "../../icons/24/Arrow/ArrowSquareOut.js";
import "../../icons/24/Arrow/ArrowUndo.js";
import "../../icons/24/Arrow/ArrowUp.js";
import "../../icons/24/Arrow/ArrowUpLeft.js";
import "../../icons/24/Arrow/ArrowUpRight.js";
import "../../icons/24/Arrow/ArrowsDownUp.js";
import "../../icons/24/Arrow/ArrowsLeftRight.js";
import "../../icons/24/Arrow/ArrowsOutCardinal.js";
import "../../icons/24/Arrow/ArrowsSort.js";
import "../../icons/24/Arrow/ChevronDoubleLeft.js";
import "../../icons/24/Arrow/ChevronDoubleRight.js";
import "../../icons/24/Arrow/ChevronRight.js";
import "../../icons/24/Arrow/ChevronUp.js";
import "../../icons/24/Arrow/CollapseWindow.js";
import "../../icons/24/Arrow/ExpandWindow.js";
import "../../icons/24/Arrow/Request.js";
import "../../icons/24/Emotion/Bad.js";
import "../../icons/24/Emotion/Good.js";
import "../../icons/24/Emotion/Neutral.js";
import "../../icons/24/Emotion/VeryBad.js";
import "../../icons/24/Emotion/VeryGood.js";
import "../../icons/24/Math/Average.js";
import "../../icons/24/Math/Divide.js";
import "../../icons/24/Math/Equals.js";
import "../../icons/24/Math/Less.js";
import "../../icons/24/Math/LessEquals.js";
import "../../icons/24/Math/Minus.js";
import "../../icons/24/Math/MinusCircle.js";
import "../../icons/24/Math/More.js";
import "../../icons/24/Math/MoreEquals.js";
import "../../icons/24/Math/NoEquals.js";
import "../../icons/24/Math/Number.js";
import "../../icons/24/Math/Plus.js";
import "../../icons/24/Math/PlusCircle.js";
import "../../icons/24/Math/X.js";
import "../../icons/24/Menu/Archive.js";
import "../../icons/24/Menu/Billing.js";
import "../../icons/24/Menu/BoardGraph.js";
import "../../icons/24/Menu/BoardText.js";
import "../../icons/24/Menu/Buildings.js";
import "../../icons/24/Menu/BurgerMenu.js";
import "../../icons/24/Menu/CalendarBlank.js";
import "../../icons/24/Menu/CalendarCheck.js";
import "../../icons/24/Menu/ChartLine.js";
import "../../icons/24/Menu/ChartLineUp.js";
import "../../icons/24/Menu/Cytology.js";
import "../../icons/24/Menu/Dashboard.js";
import "../../icons/24/Menu/Emailbook.js";
import "../../icons/24/Menu/GenderFemale.js";
import "../../icons/24/Menu/GenderMale.js";
import "../../icons/24/Menu/Hospital.js";
import "../../icons/24/Menu/Lightning.js";
import "../../icons/24/Menu/Microbiology.js";
import "../../icons/24/Menu/Microphone.js";
import "../../icons/24/Menu/Microscope.js";
import "../../icons/24/Menu/Monitor.js";
import "../../icons/24/Menu/MonitorGraph.js";
import "../../icons/24/Menu/Note.js";
import "../../icons/24/Menu/NoteSearch.js";
import "../../icons/24/Menu/Notebook.js";
import "../../icons/24/Menu/Order.js";
import "../../icons/24/Menu/Package.js";
import "../../icons/24/Menu/PencilCircle.js";
import "../../icons/24/Menu/Phone.js";
import "../../icons/24/Menu/PhoneArrow.js";
import "../../icons/24/Menu/PhoneCall.js";
import "../../icons/24/Menu/PhoneCheck.js";
import "../../icons/24/Menu/Phonebook.js";
import "../../icons/24/Menu/Plugs.js";
import "../../icons/24/Menu/PlusMinus.js";
import "../../icons/24/Menu/Relations.js";
import "../../icons/24/Menu/Robot.js";
import "../../icons/24/Menu/Room.js";
import "../../icons/24/Menu/Selections.js";
import "../../icons/24/Menu/Smartphone.js";
import "../../icons/24/Menu/Stethoscope.js";
import "../../icons/24/Menu/TestFlask.js";
import "../../icons/24/Menu/TestTube.js";
import "../../icons/24/Menu/TestTubeArchive.js";
import "../../icons/24/Menu/TestTubeControl.js";
import "../../icons/24/Menu/TestTubeReception.js";
import "../../icons/24/Menu/TestTubeRegistration.js";
import "../../icons/24/Menu/Tray.js";
import "../../icons/24/Menu/UserCircle.js";
import "../../icons/24/Menu/Wrench.js";
import "../../icons/24/Menu/FirstAidKit.js";
import "../../icons/24/Menu/СhartBar.js";
import "../../icons/24/System/Alarm.js";
import "../../icons/24/System/Barcode.js";
import "../../icons/24/System/Calendar.js";
import "../../icons/24/System/Checks.js";
import "../../icons/24/System/Clock.js";
import "../../icons/24/System/CloudDownload.js";
import "../../icons/24/System/CloudUpload.js";
import "../../icons/24/System/DotsSixHorizontal.js";
import "../../icons/24/System/DotsSixVertical.js";
import "../../icons/24/System/DotsThreeHorizontal.js";
import "../../icons/24/System/DotsThreeVertical.js";
import "../../icons/24/System/Download.js";
import "../../icons/24/System/Link.js";
import "../../icons/24/System/LinkBreak.js";
import "../../icons/24/System/Loader.js";
import "../../icons/24/System/Notification.js";
import "../../icons/24/System/QRcode.js";
import "../../icons/24/System/Settings.js";
import "../../icons/24/System/Shield.js";
import "../../icons/24/System/SignIn.js";
import "../../icons/24/System/SignOut.js";
import "../../icons/24/System/Spinner.js";
import "../../icons/24/System/Upload.js";
import "../../icons/24/System/ZoomIn.js";
import "../../icons/24/System/ZoomOut.js";
import "../../icons/24/Text/Aa.js";
import "../../icons/24/Text/AlignCenter.js";
import "../../icons/24/Text/AlignLeft.js";
import "../../icons/24/Text/AlignRight.js";
import "../../icons/24/Text/Bolder.js";
import "../../icons/24/Text/Columns.js";
import "../../icons/24/Text/H.js";
import "../../icons/24/Text/Italic.js";
import "../../icons/24/Text/ListBullets.js";
import "../../icons/24/Text/ListNumbers.js";
import "../../icons/24/Text/Rows.js";
import "../../icons/24/Text/Strikethrough.js";
import "../../icons/24/Text/Table.js";
import "../../icons/24/Text/TableDouble.js";
import "../../icons/24/Text/Underline.js";
import "../../icons/24/Warning/Attention.js";
import "../../icons/24/Warning/Error.js";
import "../../icons/24/Warning/Info.js";
import "../../icons/24/Warning/Question.js";
import "../../icons/24/Warning/Success.js";
import "../Avatar/styles.js";
import "../CheckboxGroup/Checkbox/styles.js";
import "../CheckboxGroup/styles.js";
import "../RadioGroup/Radio/styles.js";
import "../RadioGroup/styles.js";
import "../RatingButton/styles.js";
import "../FloatingActionButton/styles.js";
import "../SortingButton/styles.js";
import "../SquareButton/styles.js";
import "../Toggle/styles.js";
import "../Dialog/Dialog.js";
import "../Dialog/DialogTitle.js";
import "../Dialog/DialogActions.js";
import "../Dialog/DialogContent.js";
import "../Chips/Chip/styles.js";
import "../ResultMarksNumber/styles.js";
import "../Progress/ProgressCircle/styles.js";
import "../Loaders/LoaderCircle/styles.js";
import "../Loaders/LoaderLine/styles.js";
import "../SegmentedControl/styles.js";
import "../ResultMarksText/styles.js";
import "../Link/Link.js";
import "../Tag/Tag.js";
import "../DatePicker/constants.js";
import "../DatePicker/shared/fragments/CalendarCell/CalendarCell.js";
import "../../vendor/classnames/index.js";
import { Scrollbar } from "../Scrollbar/Scrollbar.js";
import "../DatePicker/shared/fragments/MonthYearSelector/YearSelector.js";
import "../DatePicker/components/RangePicker/context/DateRangePickerContext.js";
import "../DatePicker/components/RangePicker/context/DateRangePickerContextActions.js";
import "../DatePicker/components/DatePicker/context/DatePickerContext.js";
import "../DatePicker/components/DatePicker/context/DatePickerContextActions.js";
import "../MobileBottomSheet/MobileBottomSheet.js";
import "../ListItem/ListItem.js";
import "../Nowrap.js";
import "../List/ListItemTree/TreeListItem.js";
import "../List/ListItemTree/components/Label.js";
import "../../icons/IconsFilled/24/Alert/Success.js";
import "../../icons/IconsFilled/24/Alert/Information.js";
import "../../icons/IconsFilled/24/Alert/Attention.js";
import "../../icons/IconsFilled/24/Alert/Error.js";
import "../Tabs/styles.js";
import "../Tabs/context.js";
import "../CounterInput/Input.js";
import "../PinCodeControl/PinCodeInput.js";
const VirtualList = ({
  children,
  data: list,
  estimatedItemHeight = 50,
  sx,
  ...props
}) => {
  const containerRef = useRef(null), [scrollWindowSize, setScrollWindowSize] = useState(1e3), [scrollTop, setScrollTop] = useState(0), [itemHeights, setItemHeights] = useState(
    () => new Array(list.length).fill(estimatedItemHeight)
  ), itemHeightsRef = useRef(itemHeights);
  useEffect(() => {
    itemHeightsRef.current = itemHeights;
  }, [itemHeights]), useEffect(() => {
    setItemHeights((prev) => {
      const newHeights = prev.slice(0, list.length);
      for (; newHeights.length < list.length; )
        newHeights.push(estimatedItemHeight);
      return newHeights;
    });
  }, [list.length, estimatedItemHeight]);
  const cumulativeHeights = useMemo(() => {
    const arr = new Array(list.length + 1).fill(0);
    for (let i = 0; i < list.length; i++)
      arr[i + 1] = arr[i] + itemHeights[i];
    return arr;
  }, [itemHeights, list.length]), totalHeight = cumulativeHeights[cumulativeHeights.length - 1], handleYResize = useCallback((height) => {
    setScrollWindowSize(height);
  }, []), handleScrollY = useCallback((e) => {
    setScrollTop(e.currentTarget.scrollTop);
  }, []), findStartIndex = useCallback(
    (scrollPosition) => {
      let low = 0, high = list.length;
      for (; low < high; ) {
        const mid = low + high >>> 1;
        cumulativeHeights[mid] <= scrollPosition ? low = mid + 1 : high = mid;
      }
      return Math.max(0, low - 1);
    },
    [cumulativeHeights, list.length]
  ), { startIndex, endIndex, topOffset, bottomOffset } = useMemo(() => {
    if (list.length === 0)
      return { startIndex: 0, endIndex: -1, topOffset: 0, bottomOffset: 0 };
    const buffer = 10, viewportBottom = scrollTop + scrollWindowSize, start = findStartIndex(scrollTop);
    let end = start;
    for (; end < list.length && cumulativeHeights[end + 1] < viewportBottom; )
      end++;
    const bufferedStart = Math.max(0, start - buffer), bufferedEnd = Math.min(list.length - 1, end + buffer), topOffset2 = cumulativeHeights[bufferedStart], bottomOffset2 = totalHeight - cumulativeHeights[bufferedEnd + 1];
    return {
      startIndex: bufferedStart,
      endIndex: bufferedEnd,
      topOffset: topOffset2,
      bottomOffset: bottomOffset2
    };
  }, [
    list.length,
    cumulativeHeights,
    totalHeight,
    scrollTop,
    scrollWindowSize,
    findStartIndex
  ]), startIndexRef = useRef(startIndex);
  startIndexRef.current = startIndex;
  const measureItem = useCallback((index, node) => {
    if (node) {
      const newHeight = node.getBoundingClientRect().height;
      newHeight !== itemHeightsRef.current[index + startIndexRef.current] && setItemHeights((prev) => {
        const updated = [...prev];
        return updated[index + startIndexRef.current] = newHeight, updated;
      });
    }
  }, []), visibleData = useMemo(
    () => list.slice(startIndex, endIndex + 1),
    [list, startIndex, endIndex]
  );
  return /* @__PURE__ */ jsxs(
    Scrollbar,
    {
      "data-test-id": DATA_TEST_ID_INHERITED,
      ...props,
      onYResize: handleYResize,
      sx,
      options: { suppressScrollX: !0 },
      shadow: !0,
      suppressScrollX: !0,
      onScroll: handleScrollY,
      containerRef: (el) => containerRef.current = el,
      id: "scroll_container",
      style: { position: "relative", height: "100%", overflowY: "auto" },
      children: [
        /* @__PURE__ */ jsx("div", { style: { height: topOffset, width: "100%" } }, "top"),
        children(visibleData, measureItem, startIndex),
        /* @__PURE__ */ jsx("div", { style: { height: bottomOffset, width: "100%" } }, "bottom")
      ]
    }
  );
};
export {
  VirtualList
};
//# sourceMappingURL=VirtualList.js.map
